import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';

/**
 * PremiumGuard is a component that conditionally renders its children
 * based on the user's membership status. If the user is not premium,
 * it displays a prompt to upgrade.
 */
const PremiumGuard = ({ children }) => {
  const { userProfile } = useContext(AuthContext);
  const navigate = useNavigate();

  if (userProfile?.membershipType === 'premium') {
    return <>{children}</>;
  }

  return (
    <div className="flex flex-col items-center justify-center p-8 mt-4 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50">
      <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
      <h3 className="text-xl font-semibold text-gray-700 mb-2">This is a Premium Feature</h3>
      <p className="text-gray-500 text-center mb-6 max-w-sm">
        Upgrade your membership to unlock this and other exclusive features and find your perfect match faster.
      </p>
      <button 
        onClick={() => navigate('/premium-upgrade')}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
      >
        Upgrade to Premium
      </button>
    </div>
  );
};

export default PremiumGuard;
